const legacyCheckIfShouldRenderBanner = (elementIndex, banner) => {
  const { interval, repeat, hasBanner } = banner;
  if (!hasBanner || !interval) return false;
  const position = elementIndex + 1;
  if (position === interval) return true;
  const repeatMatch = Number.isInteger(position / interval);
  if (repeat && repeatMatch) return true;
  return false;
};
const checkNewBannerSettings = banner => {
  if (!banner) return false;

  const { repeatEvery, startingPoint, maxRepetitions } = banner;
  return repeatEvery > 0 || startingPoint > 0 || maxRepetitions > 0;
};

const checkIfShouldRenderBanner = (elementIndex, banner) => {
  if (!banner) return false;
  if (!checkNewBannerSettings(banner)) return legacyCheckIfShouldRenderBanner(elementIndex, banner);

  const { repeatEvery, startingPoint, maxRepetitions } = banner;
  const position = elementIndex + 1;
  if (position < startingPoint) return false;
  if (position === startingPoint) return true;
  const positionDifference = position - startingPoint;
  if (positionDifference < repeatEvery) return false;
  const timesRepeated = positionDifference / repeatEvery;
  const repeatMatch = Number.isInteger(timesRepeated);
  if (!repeatMatch) return false;
  return timesRepeated < maxRepetitions;
};

export { checkIfShouldRenderBanner, checkNewBannerSettings };
